import {useCurrentScopeContext} from './useCurrentScopeContext'
import {useProjectType} from './useProjectType'

export const useIsOrgPlan = () => {
  const {org, project} = useCurrentScopeContext()
  const projectType = useProjectType(project)

  return org?.type === 'org-plan' && projectType === 'org-plan'
}
